import { Link } from 'react-router-dom'
import { Button } from 'reactstrap'

const NextButton = ({
  location: { pathname },
  index,
  questions,
  onClick,
  match,
  dispatch,
  quiz,
  ...props
}) => {
  let languageData = props.language || {}

  return (
    <div className='row'>
      <div className='col px-0'>
        <div className='quiz-row-wrapper submit-next'>
          {(() => {
            const current =
              props.currentContentQuiz && props.currentContentQuiz.index > -1
                ? props.currentContentQuiz.index
                : 0
            const next =
              current == (quiz && quiz.questions && quiz.questions.length - 1)
                ? 0
                : current + 1
            // console.log('props.index next button index', props)
            return (
              <Link
                replace
                to={`${pathname}?index=${next}`}
                onClick={() => {
                  dispatch(onClick(next))
                }}
                className='quiz_next-button'
              >
                <Button color='info' outline>
                  Next
                </Button>
              </Link>
            )
          })()}
        </div>
      </div>
    </div>
  )
}

export default NextButton
